import styled from 'styled-components'

export const FeedbackFormWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const WrapperImageLeft = styled.img`
    position: absolute;
    left: 20px;
    bottom: 20px;
    width: 20%;
    @media (max-width: 768px) {
        display: none;
    }
`

export const WrapperImageRight = styled.img`
    position: absolute;
    right: 20px;
    top: 20px;
    width: 20%;
    @media (max-width: 768px) {
        display: none;
    }
`

export const BackButton = styled.div`
    font-size: 16px;
    color: #f3c520;
    cursor: pointer;
    width: max-content;
    padding: 20px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const FeedbackFormGifs = styled.div`
    width: 100%;
    .mt-auto {
        margin-top: auto;
    }
`

export const FeedbackInputForm = styled.div`
    width: 100%;
`

export const FeedbackInputWrapper = styled.div`
    padding: 3%;
`

export const FeedbackInput = styled.textarea`
    width: 94%;
    background: #333333;
    height: 150px !important;
    border: none;
    border-radius: 10px;
    padding: 3%;
    font-size: 18px;
    margin-left: 0px;
    outline: none;
    resize: none;
    color: #fff;
    font-family: Avenir;
    @media (max-width: 768px) {
        width: 94%;
    }
`

export const Main = styled.div`
    width: 42%;
    height: 100%;
    background: #000;
    @media (max-width: 768px) {
        width: 100%;
        height: 100vh;
    }
`
export const PageTitle = styled.div`
    font-size: 1.5rem;
    color: white;
    font-family: AvenirBold;
    font-weight: bold;
    text-align: center;
    width: 100%;
    margin: 30px 0 10px 0;
`

export const MainWrapper = styled.div``

export const Title = styled.div`
    color: #fff;
    font-weight: 600;
    font-size: 18px;
    line-height: 130%;
    margin: 30px 0px 5px;
    padding: 5px 10px;
    @media (max-width: 768px) {
        font-size: 16px;
    }
`

export const TextCenter = styled.div`
    width: 100%;
    text-align: center;
`

export const SubmitButton = styled.button`
    padding: 11px 22px;
    background: #f3c520;
    border-radius: 10px;
    outline: none;
    border: none;
    margin: 5px 0px 30px 0px;
    cursor: pointer;
`
export const FeedbackFormMasonary = styled.div`
    width: 94%;
    display: flex;
    justify-content: space-between;
    padding: 3%;
    align-items: flex-end;
`
export const SelectedImage = styled.img`
    width: 48%;
    height: auto;
    object-fit: contain;
    border: 3px solid #f3c520;
`

export const BackIcon = styled.div``

export const BackIconImage = styled.img`
    height: 8px;
    width: 30px;
`

export const BackIconText = styled.div``
